import { Icon, Tooltip } from "@/components/atoms";

export const renderColumnHeaderWithTooltip = (label: string, tooltip: string) => {
  const ColumnHeader = () => (
    <div className="flex items-center gap-1">
      {label}
      <Tooltip content={tooltip}>
        <Icon name="InfoCircle" size="sm" variant="Bold" className="text-neutral-dark-gray" />
      </Tooltip>
    </div>
  );
  ColumnHeader.displayName = `ColumnHeader(${label})`;
  return ColumnHeader;
};
